import { di } from 'react-magnetic-di';

/**
 * Check if the current path is a help center settings path
 * Used for in page navigation
 */
export const isHelpCenterSettingsPath = (): boolean => {
	di(window);

	if (!__SERVER__) {
		return window.location.pathname.includes('jira/helpcenter/');
	}

	return false;
};

export const getHelpCenterUUIDFromPath = (): string | undefined => {
	di(window);

	if (!isHelpCenterSettingsPath()) return '';

	if (!__SERVER__) {
		return window.location.pathname.match(
			/[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}/,
		)?.[0];
	}
	return '';
};
